import { cn } from "~/v2/utils/cn";

/** Page ticket is a fixed-width card; `fill` stretches it into a parent pane. */
export const orderTicketFrameClass = (fill?: boolean): string =>
  cn(
    "flex flex-col gap-3 p-4",
    fill
      ? "h-full min-h-0 w-full min-w-0 overflow-auto"
      : "min-w-[285px] max-w-[511px] rounded-lg border border-coolgray-200 bg-white",
  );
